import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
 "Glass facade cleaning",
  "ACP panel cleaning",
  "External window cleaning",
  "Skylight cleaning",
  "High-reach cobweb removal",
  "Building signage cleaning",
  "Stone & marble facade cleaning",
  "Cladding maintenance",
  "Pressure washing",
  "Water-fed pole cleaning",
  "Rope access services",
  "Gondola system cleaning"
];

const steps = [
  {
    number: "01",
    title: "Site Survey",
    desc: "Assess building height, facade type, access points, and safety requirements.",
  },
  {
    number: "02",
    title: "Safety Planning",
    desc: "Develop comprehensive safety plan, obtain permissions, and set up equipment.",
  },
  {
    number: "03",
    title: "Professional Cleaning",
    desc: "Execute facade cleaning using appropriate methods and certified technicians.",
  },
  {
    number: "04",
    title: "Quality Inspection",
    desc: "Conduct thorough inspection to ensure complete cleaning and safety compliance.",
  },
];

const FacadeExternalCleaningServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Facade Cleaning Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default FacadeExternalCleaningServices;
